import { render } from "./NewsletterList.vue?vue&type=template&id=074c90d5&scoped=true"
import script from "./NewsletterList.vue?vue&type=script&lang=js"
export * from "./NewsletterList.vue?vue&type=script&lang=js"

import "./NewsletterList.vue?vue&type=style&index=0&id=074c90d5&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074c90d5"]])

export default __exports__